import {doc} from "firebase/firestore";
import {db} from "../firebase";

function getCompanyId() {
  return localStorage.getItem("companyId");
}

export const companyDoc = () => doc(db, "companies", getCompanyId());
